import { UnsubscribePage } from './UnsubscribePage';

export default UnsubscribePage;
